// extracted by mini-css-extract-plugin
export default {"mailLink":"MailLink_mailLink__iDZYp"};